import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-ref-data-viewer',
    imports: [RouterModule],
    templateUrl: './ref-data-viewer.component.html',
    styleUrls: ['./ref-data-viewer.component.scss']
})
export class RefDataViewerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
